module.exports = __webpack_public_path__ + "svg_80x80/celery.e3b79f.svg";